document.addEventListener('alpine:init', () => {
  Alpine.data('bibleboxUpgrade', (bbProductHandle) => ({
    redirectURL: null,
    bbProduct: null,

    init() {
      this.bbProduct = JSON.parse(document.querySelector('#product_'+bbProductHandle+'[type="application/json"]').textContent);
    },
    async addBiblebox(bbPage) {

      // get selected main product size
      const selectedSize = this.selectedOptions[this.optionIndex.size + 1];

      // Now get BB variant of same size
      const sizeOption = this.bbProduct.options.find(o => o.name.toLowerCase() == 'size');
      const selectedSizeBBVariant = this.bbProduct.variants.find(v => v['option'+sizeOption.position] == selectedSize);

      if (!selectedSizeBBVariant) {
        console.log('No BB variant found for selected size.');
        return;
      }

      const bbProductVariantId = selectedSizeBBVariant.id;

      console.log(`Adding BibleBox with variant ID: ${bbProductVariantId}`);
      const bbKit = {
        id: bbProductVariantId,
        quantity: 1,
        properties: { _bb_upgrade_kit: true, '_bb_offer_type--free_kit': true },
      }

      if (window.location.hostname.includes('.loveinfaith.life')) {
        bbKit.selling_plan = '539590723';
      }

      const productForm = document.querySelector('product-form');
      const selectedVariantId = productForm.getElementsByClassName('product-variant-id')[0].value;

      const bbProduct = {
        id: selectedVariantId,
        quantity: 1,
        properties: { 
          _bb_upgrade_shirt: true, 
          // __member_discount_percentage: this.memberDiscount.percentage,
          __member_discount_price: this.memberDiscount.price 
        },
      }

      if (bbPage) {
        bbProduct.properties._bb_page = bbPage;
        bbKit.properties._bb_page = bbPage;
      }

      // Open side card to show progress
      Alpine.store('cart').isSideCartOpen = true;

      // Check if bb items are already existing
      const cartItems = Alpine.store('cart').cartItems;
      const bbUpgradeShirt = cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);
      const bbUpgradeKit = cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);

      // Check if BB kit already added then remove
      if (bbUpgradeKit || bbUpgradeShirt) {
        // Remove items
        await Alpine.store('cart').removeItem(bbUpgradeKit ? bbUpgradeKit.key : bbUpgradeShirt.key);
      }

      Alpine.store('cart').addItems([bbKit, bbProduct], () => {
        console.log('BibleBox added to cart');
        this.hasBiblebox = true;
        this.$dispatch('cart-updated');

        // Redirect to page
        if (this.redirectURL) {
          window.location.href = this.redirectURL;
        }
      });
    },
  }));

  Alpine.data('bibleboxSignupCarousel', () => ({
    props: {},
    sizes: ['S', 'M', 'L', 'XL', '2X', '3X', '4X'],
    selectedSize: null,
    selectedProductId: null,
    selectedBBProductId: null,
    currentStep: 1,
    maxStep: 1,
    secondStepAnimationClass: 'right-origin',
    selectedProductSwatch: null,

    init() {

      try {
        this.props = JSON.parse(document.querySelector('#biblebox_signup_carousel_settings[type="application/json"]').textContent);
      } catch(error) {
        console.error(error);
      };

      this.$watch('currentStep', (newStep) => {
        // Change direction for middle step
        if (newStep === 3) {
          this.secondStepAnimationClass = 'left-origin';
        }

        if (newStep === 1) {
          this.secondStepAnimationClass = 'right-origin';
        }
      });
    },

    get stepTitle() {
      switch (this.currentStep) {
        case 1:
          return this.props.settings.title;
        case 2:
          return this.props.settings.step_2_label;
        case 3:
          return this.props.settings.step_3_label;
        default:
          return this.props.settings.title;
      }
    },

    get products() {
      if (!this.selectedSize) {
        return this.props.allProducts;
      }

      // filter products based on selected size available
      const filteredProducts = this.props.allProducts.filter((p) => {
        const sizeOption = p.options.find(o => o.name.toLowerCase() == 'size');
        if (!sizeOption) {
          return false;
        }

        // Only list product if selected size is available
        return p.variants.find(
          (v) =>
            v[`option${sizeOption.position}`] === this.selectedSize &&
            (v.remaining_quantity > 0 || v.inventory_policy === 'continue'),
        );
      });

      return filteredProducts;

      const splittedProducts = [];
      for (let i = 0; i < filteredProducts.length; i += 1) {
        const thisProduct = filteredProducts[i];
        const colorOption = thisProduct.options.find(o => o.name.toLowerCase() == 'color')

        for (let j = 0; j < thisProduct.variants.length; j += 1) {
          const thisVariant = thisProduct.variants[j];

          const cleanColor = thisVariant[`option${colorOption.position}`].replaceAll(' ', '-').toLowerCase();
          const key = `${thisProduct.id}-${cleanColor}`;
          // console.log(key);

          if (!splittedProducts[key]) {
            splittedProducts[key] = { ...thisProduct };
            splittedProducts[key].variants = [];
          }

          splittedProducts[key].variants.push({ ...thisVariant });
        }
      }

      return Object.values(splittedProducts);
    },

    handleSizeSelected(size) {
      this.selectedSize = size;
      this.currentStep = 2;

      if (this.maxStep < this.currentStep) {
        this.maxStep = this.currentStep;
      }
    },
    handleProductSelected(productId) {
      this.selectedProductId = productId;
      // this.currentStep = 3;

      if (this.maxStep < this.currentStep) {
        this.maxStep = this.currentStep;
      }

      // Skip step 3 and select bb product 1
      this.handleBBProductSelected(this.props.bbProducts[0].product.id, 0);
    },
    async handleBBProductSelected(bbProductId, index) {
      this.selectedBBProductId = bbProductId;

      // if (this.props.bbProducts[index]) {
        // const selectedMonthNumber = this.props.bbProducts[index].month_product_title[0];
        // setCookie('LIF-BB-SELECTED-MONTH', selectedMonthNumber, 1);
      // }

      // if (this.maxStep === 3) {
      this.currentStep = 4;
      // this.$confetti.start();

      // setTimeout(() => {
      //   this.$confetti.stop();
      // }, 5000);

      if (this.maxStep < this.currentStep) {
        this.maxStep = this.currentStep;
      }
      // }

      const $this = this;

      console.log(this.selectedSize);

      const selectedProduct = this.products.find((p) => p.id === this.selectedProductId);
      console.log('selectedProduct');
      console.log(selectedProduct);

      debugger;

      const sizeOption = selectedProduct.options.find(o => o.name.toLowerCase() == 'size')
      const colorOption = selectedProduct.options.find(o => o.name.toLowerCase() == 'color')

      const selectedVariant = selectedProduct.variants.find(
        (v) =>
          v[`option${sizeOption.position}`] === this.selectedSize 
          // && (!this.selectedProductSwatch || v[`option${colorOption.position}`] === this.selectedProductSwatch),
      );
      console.log('selectedVariant');
      console.log(selectedVariant);

      const selectedBBProduct = this.props.bbProducts.find((p) => p.product.id === this.selectedBBProductId);

      console.log('selectedBBProduct');
      console.log(selectedBBProduct);

      const selectedBBVariant = selectedBBProduct.product.variants.find((v) => v.option1 === this.selectedSize);
      console.log('selectedBBVariant');
      console.log(selectedBBVariant);

      // Check if BB kit already added
      if (this.bbUpgradeKit || this.bbUpgradeShirt) {
        // Remove items
        // await this.$store.dispatch('cart/removeItemAsync', {
        //   key: [this.bbUpgradeKit.key, this.bbUpgradeShirt.key],
        // });
      }

      const cartProducts = [
        {
          quantity: 1,
          id: selectedVariant.id,
          // selling_plan: this.isSaleProduct ? this.sellingPlanId : null,
          properties: {
            _bb_upgrade_shirt: true,
          },
        },
        {
          quantity: 1,
          id: selectedBBVariant.id,
          selling_plan: selectedBBProduct.product.selling_plan_id,
          properties: {
            // _bb_upgrade_shirt: true,
            _bb_upgrade_kit: true,
          },
        },
      ];

      Alpine.store('cart').addItems(cartProducts, null, true, false);
    },
    selectStep(step) {
      console.log('selectStep: '+step);
      console.log('maxStep: '+this.maxStep);
      console.log(step <= this.maxStep);

      if (step <= this.maxStep) {
        // setTimeout(() => {
        this.currentStep = step;
        // }, 1000); // Lets wait to move animation
      }
    },
    handleProductSwatchSelected(swatch) {
      this.selectedProductSwatch = swatch;
    },
  }));

  Alpine.data('bibleboxSignupCarousel2025', () => ({
    props: {},
    showProductsPopup: false,
    sizes: [
      { value: 'S', shortName: 'S', longName: "Small"},
      { value: 'M', shortName: 'M', longName: "Medium"},
      { value: 'L', shortName: 'L', longName: "Large"},
      { value: 'XL', shortName: 'XL', longName: "Extra Large"},
      { value: '2X', shortName: '2XL', longName: "Extra Large 2"},
      { value: '3X', shortName: '3XL', longName: "Extra Large 3"},
      { value: '4X', shortName: '4XL', longName: "Extra Large 4"},
    ],
    selectedSize: null,
    selectedProductId: null,
    selectedProductSwatch: null,

    init() {

      try {
        this.props = JSON.parse(document.querySelector('#biblebox_signup_carousel_settings[type="application/json"]').textContent);
      } catch(error) {
        console.error(error);
      };
      
      this.$watch('showProductsPopup', (isShow) => {
        document.body.style.overflow = isShow ? 'hidden' : 'auto';
      });
    },
    get selectedSizeLabel() {
      const selectedSizeObject = this.sizes.find(s => s.value == this.selectedSize);
      if (selectedSizeObject) {
        return selectedSizeObject.longName;
      }

      return '';
    },
    get products() {
      if (!this.selectedSize) {
        return this.props.allProducts;
      }

      // filter products based on selected size available
      const filteredProducts = this.props.allProducts.filter((p) => {
        const sizeOption = p.options.find(o => o.name.toLowerCase() == 'size');
        if (!sizeOption) {
          return false;
        }

        // Only list product if selected size is available
        return p.variants.find(
          (v) =>
            v[`option${sizeOption.position}`] === this.selectedSize &&
            (v.remaining_quantity > 0 || v.inventory_policy === 'continue'),
        );
      });

      return filteredProducts;
    },
    async addToCart() {

      const $this = this;

      console.log(this.selectedSize);

      const selectedProduct = this.products.find((p) => p.id == this.selectedProductId);
      console.log('selectedProduct');
      console.log(selectedProduct);

      const sizeOption = selectedProduct.options.find(o => o.name.toLowerCase() == 'size')
      const colorOption = selectedProduct.options.find(o => o.name.toLowerCase() == 'color')

      const selectedVariant = selectedProduct.variants.find(
        (v) =>
          v[`option${sizeOption.position}`] === this.selectedSize 
          && (!this.selectedProductSwatch || v[`option${colorOption.position}`] == this.selectedProductSwatch),
      );
      console.log('selectedVariant');
      console.log(selectedVariant);

      const selectedBBVariant = this.props.bbProduct.variants.find((v) => v.option1 === this.selectedSize);
      console.log('selectedBBVariant');
      console.log(selectedBBVariant);

      const cartItems = Alpine.store('cart').cartItems;
      const bbUpgradeShirt = cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);
      const bbUpgradeKit = cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);

      // Check if BB kit already added
      if (bbUpgradeKit || bbUpgradeShirt) {
        // Remove items
        await Alpine.store('cart').removeItem(bbUpgradeKit ? bbUpgradeKit.key : bbUpgradeShirt.key);
      }

      const cartProducts = [
        {
          quantity: 1,
          id: selectedVariant.id,
          // selling_plan: this.isSaleProduct ? this.sellingPlanId : null,
          properties: {
            _bb_upgrade_shirt: true,
          },
        },
        {
          quantity: 1,
          id: selectedBBVariant.id,
          selling_plan: this.props.bbProduct.selling_plan_id,
          properties: {
            _bb_upgrade_kit: true,
          },
        },
      ];

      this.showProductsPopup = false;
      await Alpine.store('cart').addItems(cartProducts);
    },
    productShouldShow(productId) {
      return this.products.find(p => p.id == productId);
    },
    handleProductSwatchSelected(swatch) {
      this.selectedProductSwatch = swatch;
    },
  }));

  Alpine.data('subscriptionMembershipPricing', () => ({
    props: {},
    flktyMember: null,
    flktyRegular: null,

    init() {
      this.props = JSON.parse(document.querySelector('#biblebox_member_pricing_settings[type="application/json"]').textContent);
    }
  }));

  Alpine.data('subscriptionCollectionSlider', (isMember) => ({
    productPrice: 0,
    productPrices: [],
    activeIndex: 0,
    flkty: null,

    init() {
      try {
        const flktySettings = {
          wrapAround: true,
          draggable: false,
          pageDots: false,
          prevNextButtons: false,
          pauseAutoPlayOnHover: false,
        }

        // Only member slide should auto start, other should follow
        if (isMember) {
          flktySettings.autoPlay = 1000 * 3; // every 3 second = {

          this.flktyMember = new Flickity(this.$refs.slides, flktySettings);
          this.flktyMember.on('change', (i) => {

            const activeIndex = i % this.props.products.length;
            console.log('flktyMember index: '+activeIndex);

            this.productPrice = this.getProductPrice(activeIndex);
            this.activeIndex = activeIndex;

            // Switch regular flkty simulatiusly
            if (this.flktyRegular) {
              this.flktyRegular.select(i);
            }
          });
        } else {
          this.flktyRegular = new Flickity(this.$refs.slides, flktySettings);
          this.flktyRegular.on('change', (i) => {
            const activeIndex = i % this.props.products.length;
            this.productPrice = this.getProductPrice(activeIndex);
          });
        }

      } catch(error) {
        console.error(error);
      };

      this.productPrice = this.getProductPrice(0);
    },

    handleClick() {

      // flkty auto stop by clickng so we need to start again

      // Auto start player
      if (isMember) {
        this.flktyMember.playPlayer()
      }
    },

    getProductPrice(index) {
      // If next loop start
      if (index === this.props.products.length) {
        // eslint-disable-next-line no-param-reassign
        index = 0;
      }
      if (this.productPrices[index]) {
        // console.log(`Saved Price ${index}: ${this.productPrices[index]}`);
        return this.productPrices[index];
      }

      // Generate and Save to avoid calculate again and again
      const thisProduct = this.props.products[index];
      if (!thisProduct) {
        return null;
      }

      const firstVariantPrice = thisProduct.variants[0].price / 100;
      if (isMember) {
        this.productPrices[index] = thisProduct.member_price ? thisProduct.member_price : firstVariantPrice;
      } else {
        this.productPrices[index] = firstVariantPrice;
      }

      // console.log(`Generated Price ${index}: ${this.productPrices[index]}`);

      return this.productPrices[index];
    },
    // handleSlideChange(index) {
    //   this.productPrice = this.getProductPrice(index);
    // },
  }));
});